export class NotificationModel {
    id: number;
    notifBaseTypeId: number;
    notifBaseTypeTitle: string;
    date: Date;
    entityType: string;
    entityId: number;
    createDate: Date;
    createUserId: number;
    createUserTitle: string;
    isActive: boolean;
    title: string;
    bodyText: string;
    notifTargetTitle: string;
    isSeen: boolean;
    seenDate: Date | null;

    constructor(
        id: number,
        notifBaseTypeId: number,
        notifBaseTypeTitle: string,
        date: Date,
        entityType: string,
        entityId: number,
        createDate: Date,
        createUserId: number,
        createUserTitle: string,
        isActive: boolean,
        title: string,
        bodyText: string,
        notifTargetTitle: string,
        isSeen: boolean,
        seenDate: Date | null
    ) {
        this.id = id;
        this.notifBaseTypeId = notifBaseTypeId;
        this.notifBaseTypeTitle = notifBaseTypeTitle;
        this.date = date;
        this.entityType = entityType;
        this.entityId = entityId;
        this.createDate = createDate;
        this.createUserId = createUserId;
        this.createUserTitle = createUserTitle;
        this.isActive = isActive;
        this.title = title;
        this.bodyText = bodyText;
        this.notifTargetTitle = notifTargetTitle;
        this.isSeen = isSeen;
        this.seenDate = seenDate;
    }

    public static fromJson(json: any): NotificationModel {
        return new NotificationModel(
            json["id"],
            json["notifBaseTypeId"],
            json["notifBaseTypeTitle"],
            new Date(json["date"]),
            json["entityType"],
            json["entityId"],
            new Date(json["createDate"]),
            json["createUserId"],
            json["createUserTitle"],
            json["isActive"],
            json["title"],
            json["bodyText"],
            json["notifTargetTitle"],
            json["isSeen"],
            json["seenDate"] ? new Date(json["seenDate"]) : null
        );
    }
}

export interface NotificationDisplayModel {
    id: number;
    entityType: string;
    entityId: number;
    createDate: string;
    createTime: string;
    createUserName: string;
    title: string;
    bodyText: string;
}


export interface NotificationGetPayloadFilterModel {
    NotifBaseTypeId?: number;
    Date?: Date;
    CreateDate?: Date;
    Title?: string;
    UserId?: number;
    IsSeen?: number;
}

export interface NotificationGetPayloadModel {
    pageSize?: number;
    pageNumber?: number;
    Filters?: NotificationGetPayloadFilterModel;
}

export interface NotificationDetailGetPayloadModel {
    NotificationId?: number;
    pageIndex?: number;
    pageSize?: number;
}

export class NotificationDetailModel {
    id: number;
    userName: string;
    isSeen: boolean;
    seenDate: string;

    constructor(id: number, userName: string, isSeen: boolean, seenDate: string) {
        this.id = id;
        this.userName = userName;
        this.isSeen = isSeen;
        this.seenDate = seenDate;
    }

    public static fromJson(json: any): NotificationDetailModel {
        return new NotificationDetailModel(
            json["id"],
            json["userName"],
            json["isSeen"],
            json["seenDate"] ?? ""
        );
    }
}



export interface NotificationUserGetPayloadModel {
    IsSeen?: number;
    pageNum?: number;
    pageSize?: number;
    NotificationOrEvent?: 1 | 2;
}

export enum NotifTargetTypes {
    NotifForMe = 0,
    NotifForAll = 1,
    NotifForRole = 2,
    NotifForAnotherUser = 3
}

export interface NotificationPayloadModel {
    Id?: number;
    EntityId?: number;
    NotifBaseTypeId: number;
    Date: Date | string;
    Time: string;
    Title: string;
    BodyText: string;
    NotifTargetType: NotifTargetTypes;
    TargetIds: number[];
}


export enum NotificationOrEventTypes {
    Notification = 1,
    Event = 2,
}



export class NewNotificationModel {
    
    id: number;
    userName: string;
    entityType: string;
    entityId: number;
    createDate: Date;
    createById: number;
    createUserName: string;
    updateById: number;
    updatedDate: Date;
    forAdmin: boolean;
    isActive: boolean;
    isLegal: boolean;
    title: string;
    bodyText: string;
    isSeen: boolean|null;
    seenDate: Date | null;
    notifDate: Date ;
    constructor(
        id: number,
        userName: string,
        entityType: string,
        entityId: number,
        createDate: Date,
        createById: number,
        createUserName: string,
        updateById: number,
        updatedDate: Date,
        forAdmin: boolean,
        isActive: boolean,
        isLegal: boolean,
        title: string,
        bodyText: string,
        isSeen: boolean,
        seenDate: Date | null,
        notifDate: Date ,

    ) {
        this.id = id;
        this.userName = userName;
        this.createById = createById;
        this.createUserName =createUserName;
        this.entityType = entityType;
        this.entityId = entityId;
        this.createDate = createDate;
        this.updateById = updateById;
        this.updatedDate = updatedDate;
        this.forAdmin = forAdmin;
        this.isActive = isActive;
        this.isLegal = isLegal;
        this.title = title;
        this.bodyText = bodyText;
        this.isSeen = isSeen;
        this.seenDate = seenDate;
        this.notifDate = notifDate;
    }

    public static fromJson(json: any): NewNotificationModel {
        return new NewNotificationModel(
            json["id"],
            json["userName"],
            json["entityType"],
            json["entityId"],
            new Date(json["createDate"]),
            json["createById"],
            json["createUserName"],
            json["updateById"],
            new Date(json["updatedDate"]),
            json["forAdmin"],
            json["isActive"],
            json["isLegal"],
            json["title"],
            json["bodyText"],
            json["isSeen"],
            json["seenDate"] ? new Date(json["seenDate"]) : null,
            json["notifDate"] ,
        );
    }
}

export interface NewNotificationDisplayModel {
    id: number;
    entityType: string;
    entityId: number;
    createDate: string;
    createTime: string;
    createUserName: string;
    title: string;
    bodyText: string;
}

export interface NewNotificationGetPayloadFilterModel {
    Id?: number;
    UserId?: number;
    CreateDate?: Date|null;
    NotifDate?: Date|null;
    UserName?: string;
    Title?: string;
    BodyText?: string;
    EntityId?: number;
    EntityType?: string;
    ForAdmin?: number;
    IsSeen?: number;
}

export interface NewNotificationGetPayloadModel {
    ForAdmin?: number;
    IsSeen?: number;
    pageSize?: number;
    pageNumber?: number;
    Filters?: NewNotificationGetPayloadFilterModel;
}


export interface NewNotificationPayloadModel {
    Id?: number;
    EntityId?: number;
    EntityType: string;
    Title: string;
    BodyText: string;
    UserId: number;
    IsActive: boolean;
    IsSeen: boolean;
    ForAdmin: boolean;
    NotifDate: Date | string;
    NotifTime: string;
}

